<template>
  <b-dropdown-form class="py-1 dropdown-filter-form-n">
    <b-row>
      <b-col cols="10">
        <p>Filters</p>
      </b-col>
      <b-col cols="2">
        <feather-icon
          icon="XIcon"
          size="16"
          class="align-right"
          @click="$emit('emitHideFilter')"
        />
      </b-col>
    </b-row>
    <b-form-group label="Product Category">
      <v-select
        v-model="categoryFilterValue"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        :options="categoryOptions"
        :reduce="val => val._id"
        label="name"
        multiple
        placeholder="Select Category"
      />
    </b-form-group>
    <b-form-group label="Status">
      <v-select
        v-model="statusFilterValue"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        :options="['On Sale', 'Not On Sale']"
        placeholder="Select Status"
        :clearable="true"
      />
    </b-form-group>
    <b-form-group label="Created At">
      <b-input-group>
        <flat-pickr
          v-model="createdAtFilterValue"
          class="form-control"
          placeholder="Select Date Range"
          :config="flatPickrConfig"
        />
        <b-input-group-append is-text>
          <feather-icon
            icon="CalendarIcon"
            class="cursor-pointer"
            data-toggle
            size="18"
          />
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
    <div class="d-flex mt-1">
      <b-button
        variant="outline-primary"
        size="md"
        class="mr-1 w-100"
        @click="clearFilter"
      >
        Clear All
      </b-button>
      <b-button
        variant="primary"
        size="md"
        class="w-100"
        @click="applyFilter"
      >
        Apply Filter
      </b-button>
    </div>
  </b-dropdown-form>
</template>

<script>
import {
  BDropdownForm, BFormGroup, BInputGroup, BButton, BRow, BCol, BInputGroupAppend,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import '@core/scss/vue/libs/vue-flatpicker.scss'
import axios from '@axios'

export default {
  components: {
    BButton,
    BDropdownForm,
    BFormGroup,
    BInputGroup,
    BRow,
    BCol,
    BInputGroupAppend,
    flatPickr,
    vSelect,
  },
  props: {
    categoryFilter: {
      type: Array,
      default: () => [],
    },
    statusFilter: {
      type: [String, null],
      default: null,
    },
    createdAtFilter: {
      type: [String, null],
      default: null,
    },
  },
  data() {
    return {
      categoryFilterValue: this.categoryFilter,
      statusFilterValue: this.statusFilter,
      createdAtFilterValue: this.createdAtFilter,
      categoryOptions: [],
      flatPickrConfig: {
        wrap: true, mode: 'range', dateFormat: 'd/m/Y', enableTime: false, static: true, disableMobile: true,
      },
    }
  },
  watch: {
    categoryFilter: {
      immediate: true,
      handler(val) { this.categoryFilterValue = val },
    },
    statusFilter: {
      immediate: true,
      handler(val) { this.statusFilterValue = val },
    },
    createdAtFilter: {
      immediate: true,
      handler(val) { this.createdAtFilterValue = val },
    },
  },
  created() {
    axios.get('reservation/product-category/respond-with/name-and-id')
      .then(response => {
        this.categoryOptions = response.data.categories || []
      })
  },
  methods: {
    applyFilter() {
      this.$emit('update:categoryFilter', this.categoryFilterValue)
      this.$emit('update:statusFilter', this.statusFilterValue)
      this.$emit('update:createdAt', this.createdAtFilterValue)
      this.$emit('emitHideFilter')
    },
    clearFilter() {
      this.categoryFilterValue = []
      this.statusFilterValue = ''
      this.createdAtFilterValue = ''
      this.$emit('update:categoryFilter', this.categoryFilterValue)
      this.$emit('update:statusFilter', this.statusFilterValue)
      this.$emit('update:createdAt', this.createdAtFilterValue)
      this.$emit('emitHideFilter')
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
